import { render, staticRenderFns } from "./infos.vue?vue&type=template&id=5b2a9f4b&scoped=true&"
import script from "./infos.vue?vue&type=script&lang=js&"
export * from "./infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2a9f4b",
  null
  
)

export default component.exports